import React from 'react';
import PropTypes from 'prop-types';
import _pathEq from 'ramda/src/pathEq';
import _path from 'ramda/src/path';

import Image from './Image';

const Avatar = props => {
	const buildProfileImagePath = (id, self, cdn, nocdn) => {
		const fakeArr = [];
		const contentUrl = self ? nocdn : cdn;

		let i;
		let path = '';
		let defaultPath = "https://content-eecuhxg6gch7hahp.a03.azurefd.net/assets/common/images/profile.png";

		if (typeof id !== 'number' || !cdn || !nocdn) {
			return defaultPath;
		}

		function addCommas(idInt) {
			const idStr = `${idInt}`;
			const x = idStr.split('.');
			let x1 = x[0];
			const x2 = x.length > 1 ? `.${x[1]}` : '';
			const rgx = /(\d+)(\d{3})/;
			while (rgx.test(x1)) {
				x1 = x1.replace(rgx, '$1,$2');
			}
			return x1 + x2;
		}

		const chunks = (function getRelPath(idInt) {
			const idString = addCommas(idInt || 0);
			const idArray = idString.split(',');
			return idArray;
		})(id);

		const loopage = 3 - chunks.length;

		for (i = 0; i < loopage; i++) {
			fakeArr.push(0);
		}

		for (i = 0; i < chunks.length; i++) {
			chunks[i] = parseInt(chunks[i], 10);
			fakeArr.push(chunks[i]);
		}

		for (i = 0; i < fakeArr.length; i++) {
			path += `${fakeArr[i]}/`;
		}

		return `${contentUrl}assets/realtors/website/${path}profile.png`;
	};

	const getWidth = size => {
		let width;

		switch (size) {
			case 'xxs':
				width = 30;
				break;
			case 'xs':
				width = 36;
				break;
			case 'sm':
				width = 50;
				break;
			case 'md':
				width = 84;
				break;
			case 'lg':
				width = 110;
                break;
            case 'xl':
                width = 220;
                break;
			default:
				width = 228;
		}

		return width;
	};

	const self = _pathEq(['User2', 'WebsiteId'], props.websiteId, RESAAS);
	const cdn = _path(['Environment', 'ContentUrl'], RESAAS);
	const nocdn = _path(['Environment', 'ContentUrlNoCDN'], RESAAS);
	const path = props.src || buildProfileImagePath(props.websiteId, self, cdn, nocdn);
	const width = getWidth(props.size);
	const resize = !self;

	return (
		<div
			className={`re-avatar-${props.size} ${props.divClassName ? props.divClassName : ''} ${(props.hasProfileBadge && !props.hasPremiumPlusBadge && !props.hasGeBadge) ? 're-avatar-badge re-avatar-badge-premium' : ''}${(props.hasPremiumPlusBadge && !props.hasGeBadge) ? 're-avatar-badge re-avatar-badge-premium re-premiumplus' : ''}${props.hasGeBadge ? ' re-avatar-badge re-avatar-badge-globalelite' : ''}`}
		>
			<Image
				src={path}
				width={width}
				attributes={props.imageAttributes}
				format="jpg"
				resize={resize}
				alt={props.displayName}
				lazy={props.lazy}
				className={props.imgClassName}
			/>
		</div>
	);
};

Avatar.propTypes = {
	displayName: PropTypes.string,
	hasProfileBadge: PropTypes.bool,
	hasGeBadge: PropTypes.bool,
	hasPremiumPlusBadge: PropTypes.bool,
	imageAttributes: PropTypes.object,
	size: PropTypes.string,
	src: PropTypes.string,
	websiteId: PropTypes.number,
	lazy: PropTypes.bool,
	imgClassName: PropTypes.string,
	divClassName: PropTypes.string,
};
export default Avatar;
